<template>
  <div class="modal-mask" v-on="isCloseOnClick ? { click: closeModal } : null ">
    <div class="modal-wrapper">
      <div class="modal-container" :class="[isHidding ? closeModalSize: modalSize]">
        <div :class="[isTradingview ? 'modal-header-chart' : 'modal-header']">
          <slot name="header"></slot>
          <a style="text-decoration:none" class="close-modal" href="javascript:;" @click="closeModal">
            <span v-if="isTradingview">ปิดกราฟ</span>
            <i class="fal fa-times" v-else></i>
          </a>
        </div>
        <div :class="[isTradingview ? 'no-padding' : 'modal-body', !padding ? 'no-padding': '']">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isHidding: false
    }
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    isTradingview: {
      type: Boolean,
      default: false
    },
    isCloseOnClick: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    $route() {
      this.$route.query.openModal
        ? (document.documentElement.style.overflow = "hidden")
        : (document.documentElement.style.overflow = "")
    }
  },
  computed: {
    modalSize() {
      switch (this.options.modalSize) {
        case "full":
          return "modal-full is-showing-full"
        case "compact":
          return "modal-compact is-showing-compact"
        default:
          return "modal-tall is-showing-tall"
      }
    },
    closeModalSize() {
      switch (this.options.modalSize) {
        case "full":
          return "is-hiding-full"
        case "compact":
          return "is-hiding-compact"
        default:
          return "is-hiding-tall"
      }
    }
  },
  mounted() {
    document.documentElement.style.overflow = "hidden"
  },
  methods: {
    closeModal() {
      document.documentElement.style.overflow = ""
      if (this.isTradingview) {
        this.$emit("destroy-chart", true)
      }
      setTimeout(() => {
        this.isHidding = true
        setTimeout(() => {
          this.$emit("close-modal", true)
        }, 500)
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
.no-padding {
  padding: 0px !important;
}
.modal-mask {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.5s; /* Firefox < 16 */
  -ms-animation: fadein 0.5s; /* Internet Explorer */
  -o-animation: fadein 0.5s; /* Opera < 12.1 */
  animation: fadein 0.5s;
  .modal-wrapper {
    display: table-cell;
    vertical-align: bottom;
    .modal-container {
      width: 100%;
      height: 90%;
      bottom: 0;
      position: fixed;
      overflow: hidden;
      display: none;
      margin: 0px auto;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;

      background-color: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      // transition: all 0.3s ease;
      font-family: Helvetica, Arial, sans-serif;
      .modal-header {
        margin-top: 0;
        position: relative;
        display: inline-block;
        width: 100%;
        height: 43px;
        padding: 10px 16px;
        border-bottom: 1px solid $color-line-grey;
        .close-modal {
          position: absolute;
          right: 16px;
          top: 7px;
          @extend %font-size-l;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: $color-normal-text;
        }
      }
      .modal-header-chart {
        margin-top: 0;
        position: relative;
        display: inline-block;
        width: 100%;
        height: 43px;
        padding: 10px 16px;
        border-bottom: 1px solid $color-line-grey;
        .close-modal {
          position: absolute;
          right: 16px;
          top: 0;
          @extend %font-size-l;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: $color-normal-text;
          span {
            @extend %font-size-sss;
            font-weight: bold;
          }
        }
      }
      @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
        .modal-header-chart {
          transform: rotate(90deg);
          transform-origin: right top;
          width: 100vh;
          overflow-x: hidden;
          position: absolute;
          top: 100%;
          right: 9px;
        }
      }
      @media only screen and (orientation: landscape) {
        .modal-body {
          padding: 0 16px 0 16px !important;
        }
      }
      .modal-body {
        padding: 16px 16px 0 16px; // 60px 50px 50px
        padding-bottom: 10vh;
        overflow-y: auto;
        height: 100%;
      }
    }
    .is-showing-compact {
      @include keyframe(animateHeight-compact) {
        0% {
          height: 0%;
        }
        100% {
          height: 70%;
        }
      }
      @include animation(animateHeight-compact);
    }
    .is-hiding-compact {
      @include keyframe(collapsedModal-compact) {
        0% {
          height: 70%;
        }
        100% {
          height: 0%;
        }
      }
      @include animation(collapsedModal-compact);
    }
    .is-showing-tall {
      @include keyframe(animateHeight-tall) {
        0% {
          height: 0%;
        }
        100% {
          height: 90%;
        }
      }
      @include animation(animateHeight-tall);
    }
    .is-hiding-tall {
      @include keyframe(collapsedModal-tall) {
        0% {
          height: 90%;
        }
        100% {
          height: 0%;
        }
      }
      @include animation(collapsedModal-tall);
    }
    .is-showing-full {
      @include keyframe(animateHeight-full) {
        0% {
          height: 0%;
        }
        100% {
          height: 100%;
        }
      }
      @include animation(animateHeight-full);
    }
    .is-hiding-full {
      @include keyframe(collapsedModal-full) {
        0% {
          height: 100%;
        }
        100% {
          height: 0%;
        }
      }
      @include animation(collapsedModal-full);
    }
  }
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>